module.exports = __webpack_public_path__ + "static/media/edit.0f7a2767.svg";